import React from 'react';
import { ACTIVITY_TYPES } from '../../utils/constants';
import { fmtUSDT, fmtAgo } from '../../utils/format';

const ActivityFeed = ({ activities }) => {
  const list = (activities || []).slice().reverse();

  if (!list.length) {
    return (
      <div className="card">
        <div className="card-title">Recent Activity</div>
        <div className="empty">
          <div className="empty-icon">○</div>
          <div className="empty-title">No activity yet</div>
          <div>Your latest transactions will appear here.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-title">Recent Activity</div>
      <div className="activity-list" style={{ marginTop: 8 }}>
        {list.map((a, i) => {
          const meta = ACTIVITY_TYPES[a.activityType] || { label: 'Activity', icon: '•' };
          return (
            <div className="activity-row" key={i}>
              <div className="activity-icon">{meta.icon}</div>
              <div className="activity-body">
                <div className="activity-type">{meta.label}</div>
                <div className="activity-meta">
                  Pkg #{a.packageId} · {fmtAgo(a.timestamp)}
                  {a.fromId && a.fromId !== '0' ? ` · from #${a.fromId}` : ''}
                </div>
              </div>
              <div className="activity-amt">{fmtUSDT(a.amount)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActivityFeed;
